import weekdayHistogram, {
  days,
} from '../../../data-shapers/weekday-histogram';
import statusFilter from '../../../data-shapers/status-filter';

export default function makeData(tickets) {
  const histogram = weekdayHistogram(statusFilter(tickets, 'completed'));
  return days.map((day) => ({ day, ...histogram[day] }));
}
